/* Ardor Banner Builder: the AI design drawer ("AI design" on the tool rail). Ardor Printing. New Oct 11, 2026 (AI-BANNER).
Builds its form inside the drawer panel that assets/ardor-banner-ai-layers.js adds ([data-aba-host]). Same AI server, routes,
visitor id / email (localStorage wsIdeaVisitor / wsIdeaEmail), invisible Turnstile check and email unlock as the AI banner
generator page (/pages/ai-banner-generator, assets/ardor-banner-idea.js), so tries are shared with it. The request uses the
banner's current width x height in feet. The picked design is made print-ready (POST /api/banner/final) and handed to
ArdorBannerLayers.placeAi(), the same placement the AI page's hand-off uses (wide banners get their ends filled from the
design's own edges; "Smooth ends" when the customer picks it), on the face being edited (front, or the back when the banner
has 2 sides with a different back). The busy-edges warning and the "How should we fill the ends?" choice live ONLY here,
never in the builder itself (Dayne, Oct 8: no warning for customers' own art). The busy-edge check and the end previews are
copied in from assets/ardor-banner-idea.js when this file is built (aidrawer/banner/drawer.patch). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__aba) return;
  root.__aba = true;

  var CONF = {};
  try { CONF = JSON.parse(root.querySelector('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  var API_BASE = String(CONF.ideaApi || 'https://ws-idea-api.dayne-18a.workers.dev').replace(/\/+$/, '');
  var SITEKEY = String(CONF.turnstile || '');
  var AI_PAGE = String(CONF.ideasUrl || '/pages/ai-banner-generator');
  var LIMITS = { headline: 60, subline: 80, details: 120, notes: 300, fix: 200 };
  var STYLES = [['bold', 'Bold', 'Big type, high contrast'], ['clean', 'Clean', 'Simple, modern, lots of space'], ['fun', 'Fun', 'Bright colors, playful shapes'], ['elegant', 'Elegant', 'Classy type, refined colors'], ['vintage', 'Vintage', 'Retro badge, worn texture'], ['event', 'Event', 'Parties, sales, grand openings']];
  // [seconds, status text, only when] (same steps as the AI banner page)
  var GEN_STEPS = [[0, 'Laying out your banner…'], [10, 'Setting your words…'], [22, 'Placing your logo…', 'logo'], [34, 'Checking the spelling…'], [50, 'Double-checking every word…'], [66, 'Adding the final touches…'], [82, 'Almost there…']];
  var MAX_LOGO_PX = 1536, MAX_LOGO_BYTES = 8 * 1024 * 1024, MAX_SOURCE_BYTES = 30 * 1024 * 1024;
  var SPARK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 2.5l2.1 5.6 5.6 2.1-5.6 2.1L12 17.9l-2.1-5.6-5.6-2.1 5.6-2.1zM19 15l.9 2.3 2.3.9-2.3.9L19 21.4l-.9-2.3-2.3-.9 2.3-.9z"/></svg>';

  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) {} return null; }
  var visitor = store('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    store('wsIdeaVisitor', visitor);
  }
  var email = store('wsIdeaEmail') || '';
  var S = { style: 'bold', logo: null, logoId: '', busy: false, left: null, fixesLeft: null, finalsLeft: null, hasEmail: false, emailTries: 10, off: false, batch: null, timer: 0, pending: null, sizeKey: '', opened: false };
  var ui = {};

  // ---------- helpers ----------
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || ui.host).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || ui.host).querySelectorAll(s)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clean(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function fmt(n) { return String(Math.round(n * 100) / 100); }
  function sizeLabel(w, h) { return fmt(w) + ' x ' + fmt(h) + ' ft'; }
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }
  function track(name, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name, where: 'banner_builder' }, data || {})); } catch (e) {} }
  function BA() { return window.ArdorBannerAPI; }
  function LY() { return window.ArdorBannerLayers; }
  function validBox(lb) {
    return Array.isArray(lb) && lb.length === 4 && lb.every(function (n) { return typeof n === 'number' && isFinite(n); }) ? lb.map(function (n) { return Math.min(1, Math.max(0, n)); }) : null;
  }

  // ---------- the banner being designed ----------
  // w x h = the banner's current size in feet (what the AI is asked for); face = where the design goes
  function plan() {
    var A = BA(), c = A.cfg(), st = A.state || {};
    var two = c.sides === 2 && st.backMode === 'different';
    var face = two && A.editFace && A.editFace() === 'back' ? 'back' : 'front';
    var w = Math.round(c.W * 100) / 100, h = Math.round(c.H * 100) / 100;
    return { w: w, h: h, B: w / h, two: two, face: face };
  }
  // what placeAi() does with an image of shape A on a banner of shape B: wider than 3:1 (or taller than 1:3) = the ends are
  // filled from the design's own edges; otherwise the design fills the banner.
  function extOf(B, A) { return (B > 3 || B < 1 / 3) && (B / A > 1.03 || A / B > 1.03); }

  // ---------- server ----------
  function api(path, body, ms) {
    var opts = {};
    if (body instanceof FormData) { opts.method = 'POST'; opts.body = body; }
    else if (body) { opts.method = 'POST'; opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    var ctl = window.AbortController ? new AbortController() : null, t = 0;
    if (ctl) { opts.signal = ctl.signal; t = setTimeout(function () { ctl.abort(); }, ms || 180000); }
    return fetch(API_BASE + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        clearTimeout(t);
        if (!j || typeof j !== 'object') j = {};
        if (r.status === 402 && !j.error) j.error = 'need_email';
        if (!r.ok) { if (!j.error) j = { ok: false, error: 'server', message: 'Something went wrong on our side. Please try again.' }; j.ok = false; }
        return j;
      });
    }, function (e) {
      clearTimeout(t);
      return e && e.name === 'AbortError' ? { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' } : { ok: false, error: 'network', message: 'We couldn\'t reach our AI designer. Check your connection and try again.' };
    });
  }
  function withEmail(b) { if (S.hasEmail && email) b.email = email; return b; }
  function quota() {
    var q = 'visitor=' + encodeURIComponent(visitor) + (email ? '&email=' + encodeURIComponent(email) : '');
    return api('/api/banner/quota?' + q, null, 20000).then(function (j) {
      if (j && j.ok) {
        if (j.enabled === false) S.off = true;
        S.left = j.bannersLeft; S.fixesLeft = j.fixesLeft; S.finalsLeft = j.finalsLeft; S.hasEmail = !!j.hasEmail;
        if (j.emailBanners) S.emailTries = j.emailBanners;
      }
      syncQuota();
      return j;
    });
  }

  // ---------- Turnstile: explicit render, invisible, a fresh token for every request ----------
  var tsReady = null, tsWidget = null, tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise(function (res) {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.abaTurnstileLoaded = function () { res(true); };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=abaTurnstileLoaded';
      s.async = true; s.defer = true;
      s.onerror = function () { res(false); };
      document.head.appendChild(s);
    });
    return tsReady;
  }
  function botToken() {
    return loadTurnstile().then(function (ok) {
      if (!ok || !window.turnstile) return '';
      return new Promise(function (res) {
        tsResolve = res;
        var take = function (t) { var r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
        try {
          if (tsWidget === null) tsWidget = window.turnstile.render($('[data-aba-ts]'), { sitekey: SITEKEY, execution: 'execute', appearance: 'interaction-only', callback: take, 'error-callback': function () { take(''); } });
          else window.turnstile.reset(tsWidget);
          window.turnstile.execute(tsWidget);
        } catch (e) { take(''); }
        setTimeout(function () { if (tsResolve === res) take(''); }, 45000);
      });
    });
  }

  // ---------- logo: any picture, made a PNG up to 1536 px for the AI (SVGs without a size get one first) ----------
  function svgSized(file) {
    return file.text().then(function (t) {
      var d = new DOMParser().parseFromString(t, 'image/svg+xml'), s = d.documentElement;
      if (!s || String(s.nodeName).toLowerCase() !== 'svg') return file;
      var wa = s.getAttribute('width') || '', ha = s.getAttribute('height') || '', w = parseFloat(wa), h = parseFloat(ha);
      if (!(w > 0 && h > 0) || /%/.test(wa + ha)) {
        var vb = String(s.getAttribute('viewBox') || '').split(/[\s,]+/).map(parseFloat);
        if (vb.length === 4 && vb[2] > 0 && vb[3] > 0) { w = vb[2]; h = vb[3]; } else { w = 1024; h = 1024; }
      }
      var k = MAX_LOGO_PX / Math.max(w, h);
      s.setAttribute('width', String(Math.round(w * k))); s.setAttribute('height', String(Math.round(h * k)));
      return new Blob([new XMLSerializer().serializeToString(s)], { type: 'image/svg+xml' });
    }).catch(function () { return file; });
  }
  function toPng(file) {
    var isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name || '');
    return (isSvg ? svgSized(file) : Promise.resolve(file)).then(function (src) {
      return new Promise(function (res, rej) {
        var u = URL.createObjectURL(src), im = new Image();
        im.onload = function () {
          var w = im.naturalWidth || 800, h = im.naturalHeight || 800, k = Math.min(1, MAX_LOGO_PX / Math.max(w, h));
          var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(w * k)); cv.height = Math.max(1, Math.round(h * k));
          cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height);
          URL.revokeObjectURL(u);
          cv.toBlob(function (b) { if (b) res(b); else rej(new Error('png')); }, 'image/png');
        };
        im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
        im.src = u;
      });
    });
  }
  function uploadLogo() {
    if (!S.logo) return Promise.resolve('');
    if (S.logoId) return Promise.resolve(S.logoId);
    return toPng(S.logo).then(function (b) {
      if (b.size > MAX_LOGO_BYTES) throw { message: 'Your logo is too big. Try a smaller file.' };
      var fd = new FormData(); fd.append('file', b, 'logo.png'); fd.append('visitor', visitor);
      return api('/api/banner/logo', fd, 60000);
    }, function () { throw { message: 'We couldn\'t read that logo. Upload a PNG, JPG or SVG file.' }; }).then(function (j) {
      if (!j.ok || !j.logoId) throw j;
      S.logoId = j.logoId; return j.logoId;
    });
  }

  /* ---------- busy edges (same check as the banner builder, ardor-banner-layers.js) ---------- */
  const EDGE_BUSY = 2.5;
  // How streaky a design's stretched ends will look. Looks at the outer 2% of each edge that gets stretched,
  // sampled about 96 steps along the edge, and measures change in both directions: plain colors, smooth
  // gradients and stripes that already run straight off the edge score near 0; photos, busy textures and
  // text or shapes cut by the edge score high. Returns { a, b, score, busy } (a = left/top, b = right/bottom).
  function edgeBusy(img, wide) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return null;
    var L = wide ? ih : iw, st = Math.max(1, L / 96);
    var n = Math.max(16, Math.round(L / st)), d = Math.max(4, Math.round((wide ? iw : ih) * 0.02 / st)), depth = d * st;
    var cw = wide ? d : n, ch = wide ? n : d, res = [];
    for (var s = 0; s < 2; s++) {
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      if (wide) x.drawImage(img, s ? iw - depth : 0, 0, depth, ih, 0, 0, cw, ch);
      else x.drawImage(img, 0, s ? ih - depth : 0, iw, depth, 0, 0, cw, ch);
      var p = x.getImageData(0, 0, cw, ch).data;
      // per block along the edge (8 blocks): mean change along the edge and across it, max over R, G, B
      var B = 8, al = new Float64Array(B), ac = new Float64Array(B), na = new Float64Array(B), nc = new Float64Array(B);
      for (var yy = 0; yy < ch; yy++) for (var xx = 0; xx < cw; xx++) {
        var i = (yy * cw + xx) * 4, along = wide ? yy : xx, blk = Math.min(B - 1, Math.floor(along * B / n));
        if (xx + 1 < cw) {
          var dx = Math.max(Math.abs(p[i] - p[i + 4]), Math.abs(p[i + 1] - p[i + 5]), Math.abs(p[i + 2] - p[i + 6]));
          if (wide) { ac[blk] += dx; nc[blk]++; } else { al[blk] += dx; na[blk]++; }
        }
        if (yy + 1 < ch) {
          var j = i + cw * 4, dy = Math.max(Math.abs(p[i] - p[j]), Math.abs(p[i + 1] - p[j + 1]), Math.abs(p[i + 2] - p[j + 2]));
          if (wide) { al[blk] += dy; na[blk]++; } else { ac[blk] += dy; nc[blk]++; }
        }
      }
      var sum = 0, top = 0;
      for (var k = 0; k < B; k++) {
        var v = Math.sqrt((na[k] ? al[k] / na[k] : 0) * (nc[k] ? ac[k] / nc[k] : 0));
        sum += v; if (v > top) top = v;
      }
      res.push(Math.max(sum / B, top * 0.5));
    }
    var score = Math.max(res[0], res[1]);
    return { a: res[0], b: res[1], score: score, busy: score > EDGE_BUSY };
  }


  /* ---------- end previews (same drawing as the banner builder's extend(), ardor-banner-layers.js) ---------- */
  // Draws the design at the banner's real shape with its ends filled, stretched (as the builder does by default)
  // or smooth (&ends=smooth), so the customer can pick before the print version is made. size = preview short side.
  function mkC(w, h) { const c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function composeEnds(img, B, smooth, size) {
    const wide = B > 1, nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
    const k = Math.min(1, size / (wide ? nh : nw));
    const src = mkC(nw * k, nh * k), sx0 = src.getContext('2d');
    sx0.imageSmoothingEnabled = true; sx0.imageSmoothingQuality = 'high'; sx0.drawImage(img, 0, 0, src.width, src.height);
    const iw0 = src.width, ih0 = src.height;
    let cw, ch;
    if (wide) { ch = ih0; cw = Math.round(ih0 * B); } else { cw = iw0; ch = Math.round(iw0 / B); }
    const iw = wide ? Math.round(iw0 * ch / ih0) : cw, ih = wide ? ch : Math.round(ih0 * cw / iw0);
    const ox = wide ? Math.round((cw - iw) / 2) : 0, oy = wide ? 0 : Math.round((ch - ih) / 2);
    const cv = mkC(cw, ch), x = cv.getContext('2d');
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    const A = wide ? ['l', 0, 0, ox, ch, 'r', ox + iw, 0, cw - ox - iw, ch] : ['t', 0, 0, cw, oy, 'b', 0, oy + ih, cw, ch - oy - ih];
    for (let q = 0; q < 10; q += 5) (smooth ? soften : side)(x, src, iw0, ih0, A[q], A[q + 1], A[q + 2], A[q + 3], A[q + 4]);
    x.drawImage(src, ox, oy, iw, ih);
    if (smooth) {
      const f = Math.max(2, Math.round((wide ? iw : ih) * 0.05));
      if (wide) { soften(x, src, iw0, ih0, 'l', ox, 0, f, ch, 1); soften(x, src, iw0, ih0, 'r', ox + iw - f, 0, f, ch, 1); }
      else { soften(x, src, iw0, ih0, 't', 0, oy, cw, f, 1); soften(x, src, iw0, ih0, 'b', 0, oy + ih - f, cw, f, 1); }
    }
    return cv;
  }
  // soft fill for one side: the outer 6% of the design averaged into 6 steps along the edge, then
  // stretched smoothly over the side. feather = 1 draws it over the design's own edge, fading out inward.
  function soften(x, img, iw0, ih0, where, dx, dy, dw, dh, feather) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', band = Math.max(1, Math.round((horiz ? iw0 : ih0) * 0.06));
    var mid = horiz ? mkC(1, 64) : mkC(64, 1), mx = mid.getContext('2d');
    mx.imageSmoothingEnabled = true; mx.imageSmoothingQuality = 'high';
    if (where === 'l') mx.drawImage(img, 0, 0, band, ih0, 0, 0, 1, 64);
    if (where === 'r') mx.drawImage(img, iw0 - band, 0, band, ih0, 0, 0, 1, 64);
    if (where === 't') mx.drawImage(img, 0, 0, iw0, band, 0, 0, 64, 1);
    if (where === 'b') mx.drawImage(img, 0, ih0 - band, iw0, band, 0, 0, 64, 1);
    var small = horiz ? mkC(1, 6) : mkC(6, 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(mid, 0, 0, small.width, small.height);
    var soft = mkC(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    if (feather) {
      var g = where === 'l' ? so.createLinearGradient(0, 0, dw, 0) : where === 'r' ? so.createLinearGradient(dw, 0, 0, 0)
        : where === 't' ? so.createLinearGradient(0, 0, 0, dh) : so.createLinearGradient(0, dh, 0, 0);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    }
    x.drawImage(soft, dx, dy);
  }
  function side(x, img, iw0, ih0, where, dx, dy, dw, dh) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', n = Math.max(1, Math.min(4, horiz ? iw0 : ih0));
    var line = horiz ? mkC(1, dh) : mkC(dw, 1), lx = line.getContext('2d');
    lx.imageSmoothingEnabled = true; lx.imageSmoothingQuality = 'high';
    if (where === 'l') lx.drawImage(img, 0, 0, n, ih0, 0, 0, 1, dh);
    if (where === 'r') lx.drawImage(img, iw0 - n, 0, n, ih0, 0, 0, 1, dh);
    if (where === 't') lx.drawImage(img, 0, 0, iw0, n, 0, 0, dw, 1);
    if (where === 'b') lx.drawImage(img, 0, ih0 - n, iw0, n, 0, 0, dw, 1);
    var sharp = mkC(dw, dh), sx = sharp.getContext('2d');
    sx.imageSmoothingEnabled = false;
    sx.drawImage(line, 0, 0, dw, dh);
    var len = horiz ? dh : dw, k = Math.max(2, Math.round(len / 40));
    var small = horiz ? mkC(1, Math.max(2, Math.round(dh / k))) : mkC(Math.max(2, Math.round(dw / k)), 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(line, 0, 0, small.width, small.height);
    var soft = mkC(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    var fade = Math.max(1, Math.min(horiz ? dw : dh, len * 0.3)), g;
    if (where === 'l') g = so.createLinearGradient(dw, 0, dw - fade, 0);
    else if (where === 'r') g = so.createLinearGradient(0, 0, fade, 0);
    else if (where === 't') g = so.createLinearGradient(0, dh, 0, dh - fade);
    else g = so.createLinearGradient(0, 0, 0, fade);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,1)');
    so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    sx.drawImage(soft, 0, 0);
    x.drawImage(sharp, dx, dy);
  }

  // (end of the part copied from assets/ardor-banner-idea.js: EDGE_BUSY, edgeBusy, mkC, composeEnds, soften, side)

  // ---------- UI ----------
  function build(host) {
    ui.host = host;
    var styles = STYLES.map(function (s) {
      return '<button type="button" class="aba-style" data-aba-s="' + s[0] + '" aria-pressed="' + (s[0] === S.style ? 'true' : 'false') + '"><b>' + esc(s[1]) + '</b><small>' + esc(s[2]) + '</small></button>';
    }).join('');
    host.innerHTML =
      '<div class="aba">' +
      '<p class="abl-help aba-lead">Type your words and pick a style. Our AI draws 4 designs at your banner\'s size, <b data-aba-size></b>. Tap one to put it on your banner, then move or resize it.</p>' +
      '<p class="aba-face" data-aba-face hidden></p>' +
      '<label class="aba-field"><span>Headline <em>(required)</em></span><input class="abl-input" data-aba-line="headline" maxlength="' + LIMITS.headline + '" placeholder="e.g. Grand Opening" autocomplete="off"></label>' +
      '<label class="aba-field"><span>Second line <em>(optional)</em></span><input class="abl-input" data-aba-line="subline" maxlength="' + LIMITS.subline + '" placeholder="e.g. 20% off this weekend" autocomplete="off"></label>' +
      '<label class="aba-field"><span>Details <em>(phone, website, address)</em></span><input class="abl-input" data-aba-line="details" maxlength="' + LIMITS.details + '" placeholder="e.g. 425-555-0123 · acme.com" autocomplete="off"></label>' +
      '<p class="aba-hint">We\'ll spell it exactly as you type it.</p>' +
      '<div class="aba-field"><span>Pick a style</span><div class="aba-styles" role="group" aria-label="Style">' + styles + '</div></div>' +
      '<label class="aba-field"><span>Describe the style <em>(optional)</em></span><textarea class="abl-input aba-notes" rows="2" data-aba-notes maxlength="' + LIMITS.notes + '" placeholder="e.g. navy and gold, a coffee cup, for our grand opening"></textarea></label>' +
      '<div class="aba-field"><span>Your logo <em>(optional)</em></span>' +
      '<div class="aba-logo"><input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" data-aba-logo-in hidden><button type="button" class="aba-btn aba-btn--ghost" data-aba-logo-btn>Add your logo</button><span class="aba-logo__name" data-aba-logo-name></span><button type="button" class="aba-x" data-aba-logo-x hidden aria-label="Remove the logo">&times;</button></div>' +
      '<p class="aba-hint">We\'ll build the design around it. After you pick a design, you can also place your exact logo file.</p></div>' +
      '<div class="aba-gate" data-aba-gate hidden>' +
      '<p class="aba-gate__t"><b>You\'re on a roll!</b> Add your email to unlock <span data-aba-gate-n>10</span> banner tries a day (4 designs each). We\'ll send you banner deals too.</p>' +
      '<input class="abl-input" type="email" data-aba-email placeholder="you@example.com" autocomplete="email" aria-label="Your email">' +
      '<p class="aba-err" data-aba-gate-err role="alert" hidden></p>' +
      '<button type="button" class="aba-btn aba-btn--dark" data-aba-email-go>Unlock my designs</button>' +
      '<small class="aba-fine">By continuing you agree to get emails from Ardor Printing. Unsubscribe anytime.</small>' +
      '</div>' +
      '<p class="aba-err" data-aba-err role="alert" hidden></p>' +
      '<button type="button" class="aba-btn aba-btn--go" data-aba-go>' + SPARK + '<span data-aba-go-label>Design my banner</span></button>' +
      '<p class="aba-quota" data-aba-quota></p>' +
      '<div class="aba-status" data-aba-status aria-live="polite" hidden><span class="aba-spin" aria-hidden="true"></span><span data-aba-status-t></span></div>' +
      '<div class="aba-results" data-aba-results></div>' +
      '<div class="aba-ts" data-aba-ts></div>' +
      '<p class="abl-help aba-more">Want more room to try ideas? <a data-aba-page href="' + esc(AI_PAGE) + '">Open the full AI generator</a></p>' +
      '</div>';
    host.addEventListener('click', onClick);
    host.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target) return;
      if (e.target.hasAttribute('data-aba-email')) { e.preventDefault(); useEmail(); }
      else if (e.target.hasAttribute('data-aba-fixin')) { e.preventDefault(); var c = e.target.closest('[data-aba-card]'); if (c) fixDesign(c.getAttribute('data-aba-card'), e.target.value); }
      else if (e.target.hasAttribute('data-aba-line')) { e.preventDefault(); generate(); }
    });
    $('[data-aba-logo-in]').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; e.target.value = '';
      if (!f) return;
      if (f.size > MAX_SOURCE_BYTES) { showErr('That logo file is too big. Try one under 30 MB.'); return; }
      S.logo = f; S.logoId = ''; syncLogo(); showErr('');
    });
    host.addEventListener('input', function (e) { if (e.target && e.target.hasAttribute('data-aba-line')) showErr(''); });
    syncLogo(); syncSize();
    // the size, sides and face can change while the drawer is open: keep the size, the face note and the previews current
    var later = 0, resync = function () { clearTimeout(later); later = setTimeout(syncSize, 60); };
    ['click', 'change', 'input'].forEach(function (ev) { root.addEventListener(ev, function (e) { if (!ui.host.contains(e.target)) resync(); }); });
    var chip = root.querySelector('[data-abb-chip-size]');
    if (chip && window.MutationObserver) new MutationObserver(resync).observe(chip, { childList: true, characterData: true, subtree: true });
    // first time the drawer opens: tries left and the bot check (not on every page view)
    var panel = host.closest('[data-abl-panel]');
    var onOpen = function () { if (panel && panel.hidden) return; syncSize(); if (!S.opened) { S.opened = true; quota(); loadTurnstile(); } };
    if (panel && window.MutationObserver) new MutationObserver(onOpen).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-abl-tool="ai"], [data-abl-idea]')) setTimeout(onOpen, 0); });
    onOpen();
  }
  function onClick(e) {
    var b = e.target.closest('button, a'); if (!b || !ui.host.contains(b)) return;
    if (b.hasAttribute('data-aba-s')) { S.style = b.getAttribute('data-aba-s'); $$('[data-aba-s]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); return; }
    if (b.hasAttribute('data-aba-logo-btn')) { $('[data-aba-logo-in]').click(); return; }
    if (b.hasAttribute('data-aba-logo-x')) { S.logo = null; S.logoId = ''; syncLogo(); return; }
    if (b.hasAttribute('data-aba-go')) { generate(); return; }
    if (b.hasAttribute('data-aba-email-go')) { useEmail(); return; }
    var c = b.closest('[data-aba-card]'), id = c ? c.getAttribute('data-aba-card') : '';
    if (b.hasAttribute('data-aba-use')) { if (c && c.getAttribute('data-busy') === '1') askEnds(c, id); else useDesign(id, ''); return; }
    if (b.hasAttribute('data-aba-end')) { var k = b.getAttribute('data-aba-end'); closeEnds(c); track('ardor_banner_ai_ends', { ends: k }); useDesign(id, k); return; }
    if (b.hasAttribute('data-aba-ends-back')) { closeEnds(c); return; }
    if (b.hasAttribute('data-aba-fix')) {
      var box = $('[data-aba-fixbox]', c), open = box.hidden;
      box.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var inp = $('[data-aba-fixin]', c), img = findImg(id);
        var wrong = img && img.check && Array.isArray(img.check.wrong) ? img.check.wrong.filter(function (x) { return x && x.expected && x.seen; })[0] : null;
        if (wrong && !inp.value) inp.value = 'Change "' + wrong.seen + '" to "' + wrong.expected + '"';
        try { inp.focus({ preventScroll: true }); } catch (er) {}
        reveal($('[data-aba-fixbox]', c));
      }
      return;
    }
    if (b.hasAttribute('data-aba-fixgo')) { fixDesign(id, $('[data-aba-fixin]', c).value); return; }
    if (b.hasAttribute('data-aba-page')) { b.href = pageHref(); track('ardor_banner_ai_full_page', {}); }
  }
  function pageHref() { var p = plan(); return AI_PAGE + (AI_PAGE.indexOf('?') < 0 ? '?' : '&') + 'w=' + fmt(p.w) + '&h=' + fmt(p.h); }
  function syncSize() {
    if (!ui.host || !BA()) return;
    var p = plan();
    var s = $('[data-aba-size]'); if (s) s.textContent = sizeLabel(p.w, p.h);
    var f = $('[data-aba-face]');
    if (f) {
      f.hidden = !p.two;
      f.textContent = p.face === 'back' ? 'It goes on the back of your banner (the side you are editing).' : 'It goes on the front of your banner. To design the back, switch to Back first.';
    }
    var a = $('[data-aba-page]'); if (a) a.setAttribute('href', pageHref());
    var key = p.w + 'x' + p.h + p.face;
    if (S.batch && key !== S.sizeKey && !S.busy) showResults();
  }
  function syncLogo() {
    $('[data-aba-logo-name]').textContent = S.logo ? S.logo.name : '';
    $('[data-aba-logo-x]').hidden = !S.logo;
    $('[data-aba-logo-btn]').textContent = S.logo ? 'Change logo' : 'Add your logo';
  }
  function syncQuota() {
    var q = $('[data-aba-quota]'); if (!q) return;
    if (S.off) { q.textContent = ''; showErr('The banner generator is taking a short break. Please try again later.'); $('[data-aba-go]').disabled = true; return; }
    var n = $('[data-aba-gate-n]'); if (n) n.textContent = String(S.emailTries);
    $$('[data-aba-fixleft]').forEach(function (x) { x.textContent = fixesText(); });
    if (S.left == null) { q.textContent = ''; return; }
    var k = S.left;
    if (S.hasEmail) q.textContent = k > 0 ? k + (k === 1 ? ' try' : ' tries') + ' left today' : 'No tries left today';
    else q.textContent = k > 0 ? k + ' free ' + (k === 1 ? 'try' : 'tries') + ' · 4 designs each · no sign-up' : 'Add your email for ' + S.emailTries + ' tries a day';
  }
  function fixesText() { return S.fixesLeft == null ? '' : S.fixesLeft + (S.fixesLeft === 1 ? ' fix' : ' fixes') + ' left today'; }
  function showErr(m) { var e = $('[data-aba-err]'); if (!e) return; e.textContent = m || ''; e.hidden = !m; if (m) reveal(e); }
  function cardOf(id) { return id ? ui.host.querySelector('[data-aba-card="' + String(id).replace(/[^0-9a-zA-Z_-]/g, '') + '"]') : null; }
  function cardErr(id, m) { var c = cardOf(id), e = c && $('[data-aba-cerr]', c); if (!e) { showErr(m); return; } e.textContent = m || ''; e.hidden = !m; if (m) reveal(e); }
  function findImg(id) { return S.batch ? S.batch.images.filter(function (x) { return x.id === id; })[0] : null; }
  // v3: bring n into view. When the drawer scrolls on its own (desktop), only the drawer scrolls; when the drawer is as
  // tall as its content (the stacked tablet and phone layouts), the page scrolls. top = put n at the top.
  function reveal(n, top) {
    var b = ui.host; if (!b || !n) return;
    var inner = b.scrollHeight > b.clientHeight + 1, vh = window.innerHeight || document.documentElement.clientHeight;
    var r = n.getBoundingClientRect(), br = inner ? b.getBoundingClientRect() : { top: 90, bottom: vh, height: vh - 90 };
    if (!top && r.top >= br.top && r.bottom <= br.bottom) return;
    var dy = r.top - br.top - 8;
    if (!top && r.top >= br.top && r.height < br.height) dy = r.bottom - br.bottom + 8;
    try { (inner ? b : window).scrollBy({ top: dy, behavior: 'smooth' }); } catch (e) { if (inner) b.scrollTop += dy; else window.scrollBy(0, dy); }
  }
  // busy: everything in the drawer is off until the server answers; the status line counts the seconds
  function busy(on, text, steps) {
    S.busy = on;
    $$('button, input, textarea').forEach(function (x) { x.disabled = on; });
    var s = $('[data-aba-status]'), t = $('[data-aba-status-t]'); clearInterval(S.timer);
    if (!on) { s.hidden = true; t.textContent = ''; $('[data-aba-go-label]').textContent = 'Design my banner'; if (S.off) $('[data-aba-go]').disabled = true; return; }
    var t0 = Date.now();
    s.hidden = false;
    var tick = function () {
      var sec = Math.round((Date.now() - t0) / 1000), msg = text;
      if (steps) steps.forEach(function (st) { if (sec >= st[0]) msg = st[1]; });
      t.textContent = msg + ' ' + sec + ' s';
    };
    tick(); S.timer = setInterval(tick, 1000);
    if (steps) $('[data-aba-go-label]').textContent = 'Designing…';
  }
  function readLines() {
    var L = {};
    $$('[data-aba-line]').forEach(function (x) { var k = x.getAttribute('data-aba-line'), v = clean(x.value).slice(0, LIMITS[k]); if (v) L[k] = v; });
    return L;
  }

  // ---------- email unlock (same as the AI banner page: saved for the AI tools + Shopify customer form into a hidden frame) ----------
  function openGate(retry, kind) {
    S.pending = retry ? { kind: kind || '', run: retry } : null;
    var g = $('[data-aba-gate]'); g.hidden = false;
    var e = $('[data-aba-email]'); if (e) { e.value = email || ''; }
    var ge = $('[data-aba-gate-err]'); ge.hidden = true; ge.textContent = '';
    reveal(g);
    setTimeout(function () { try { e.focus({ preventScroll: true }); } catch (er) {} }, 60);
    track('ardor_banner_ai_gate_shown', {});
  }
  function subscribe(addr) {
    var f = document.getElementById('aba-customer');
    if (!f) return;
    var field = f.querySelector('[name="contact[email]"]'); if (field) field.value = addr;
    f.target = 'aba-sink';
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (e2) {} }
  }
  function useEmail() {
    var v = clean($('[data-aba-email]').value), ge = $('[data-aba-gate-err]');
    if (!validEmail(v)) { ge.textContent = 'Please enter a valid email.'; ge.hidden = false; try { $('[data-aba-email]').focus(); } catch (e) {} return; }
    email = v; store('wsIdeaEmail', v); S.hasEmail = true;
    subscribe(v);
    track('ardor_banner_ai_email', {});
    quota().then(function () {
      $('[data-aba-gate]').hidden = true;
      var next = S.pending; S.pending = null;
      if (next && !(next.kind === 'generate' && S.left === 0)) next.run();
    });
  }

  // ---------- generate 4 designs at the banner's size ----------
  function generate() {
    if (S.busy || S.off) return;
    var lines = readLines();
    if (!lines.headline) { showErr('Type the headline for your banner.'); var h = $('[data-aba-line="headline"]'); if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} reveal(h); } return; }
    if (!S.hasEmail && S.left === 0) { openGate(generate, 'generate'); return; }
    showErr(''); $('[data-aba-gate]').hidden = true;
    var p = plan(), notes = clean($('[data-aba-notes]').value).slice(0, LIMITS.notes);
    busy(true, '', GEN_STEPS.filter(function (s) { return s[2] !== 'logo' || !!S.logo; }));
    uploadLogo().then(function (logoId) {
      return botToken().then(function (token) {
        var body = withEmail({ visitor: visitor, token: token, widthFt: p.w, heightFt: p.h, style: S.style, styleNotes: notes, lines: lines });
        if (logoId) body.logoId = logoId;
        return api('/api/banner/generate', body, 240000).then(function (j) { return { j: j, logoId: logoId }; });
      });
    }).then(function (r) {
      var j = r.j;
      busy(false);
      if (j.bannersLeft != null) S.left = j.bannersLeft;
      if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
      if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
        if (j.error === 'need_email') { S.left = 0; syncQuota(); openGate(generate, 'generate'); return; }
        syncQuota();
        showErr(j.message || 'We couldn\'t make your designs this time. Please try again.');
        return;
      }
      if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
      syncQuota();
      S.batch = { w: p.w, h: p.h, style: S.style, notes: notes, lines: lines, logoId: r.logoId || '', images: j.images.slice(0, 4) };
      showResults();
      reveal($('[data-aba-results]'), true);
      track('ardor_banner_ai_generated', { style: S.style, w: p.w, h: p.h, logo: !!r.logoId, shown: S.batch.images.length });
    }, function (err) {
      busy(false);
      showErr((err && err.message) || 'We couldn\'t upload your logo. Try another file, or remove it and try again.');
    });
  }

  // ---------- results: each design shown at the banner's real shape ----------
  function showResults() {
    var box = $('[data-aba-results]'), b = S.batch; box.textContent = '';
    if (!b) return;
    var p = plan();
    S.sizeKey = p.w + 'x' + p.h + p.face;
    box.appendChild(el('h3', 'aba-h', 'Your designs'));
    box.appendChild(el('p', 'abl-help', 'Tap <b>Use this design</b> to put it on your ' + (p.two ? (p.face === 'back' ? 'banner\'s back' : 'banner\'s front') : 'banner') + '. You can move and resize it after.'));
    var grid = el('div', 'aba-grid' + (p.B >= 1.6 ? ' aba-grid--one' : ''));
    grid.setAttribute('role', 'list');
    b.images.forEach(function (im, i) { grid.appendChild(cardFor(im, i, p)); });
    box.appendChild(grid);
    box.appendChild(el('p', 'abl-help aba-again', 'Not quite right? Change the words or style above and tap Design my banner again.'));
  }
  function cardFor(im, i, p) {
    var A = im.w > 0 && im.h > 0 ? im.w / im.h : Math.min(3, Math.max(1 / 3, p.B));
    var ext = extOf(p.B, A), flagged = !!(im.check && im.check.ok === false), n = i + 1;
    var c = el('article', 'aba-card' + (flagged ? ' is-flagged' : ''));
    c.setAttribute('role', 'listitem'); c.setAttribute('aria-label', 'Design ' + n);
    c.setAttribute('data-aba-card', im.id);
    c.innerHTML =
      '<div class="aba-frame' + (ext ? ' is-art' : '') + '" style="--ar:' + (ext ? A : p.B) + '"><img class="aba-img" alt="" decoding="async">' + (im.fixedFrom ? '<span class="aba-badge">Fixed</span>' : '') + '</div>' +
      (ext ? '<p class="aba-note" data-aba-extnote>We\'ll extend the background to your full ' + esc(sizeLabel(p.w, p.h)) + ' size:</p><div class="aba-strip" data-aba-strip style="--ar:' + p.B + '"></div>' : '') +
      (flagged ? '<p class="aba-flag">This one may have a spelling or logo mistake. Use Fix a word or pick another.</p>' : '') +
      '<p class="aba-err aba-cerr" data-aba-cerr role="alert" hidden></p>' +
      '<div class="aba-acts"><button type="button" class="aba-btn aba-btn--dark" data-aba-use>Use this design</button><button type="button" class="aba-btn aba-btn--ghost" data-aba-fix aria-expanded="false">Fix a word</button></div>' +
      '<div class="aba-fixbox" data-aba-fixbox hidden><input class="abl-input" data-aba-fixin maxlength="' + LIMITS.fix + '" placeholder="e.g. Change &quot;Snohomsh&quot; to &quot;Snohomish&quot;" autocomplete="off" aria-label="What should we fix?"><button type="button" class="aba-btn aba-btn--ghost" data-aba-fixgo>Fix it</button><small data-aba-fixleft>' + esc(fixesText()) + '</small></div>';
    var img = $('.aba-img', c);
    img.alt = 'Banner design ' + n + ': ' + ((S.batch && S.batch.lines.headline) || '');
    img.addEventListener('load', function () {
      c.classList.add('is-in');
      if (!ext) return;
      var wide = p.B > A, strip = $('[data-aba-strip]', c);
      try { strip.appendChild(composeEnds(img, p.B, false, previewSize(p.B, 160, 1200))); } catch (e) { strip.hidden = true; }
      var eb = null;
      try { eb = edgeBusy(img, wide); } catch (e) { /* not readable: keep the plain note */ }
      if (!eb || !eb.busy) return;
      c.setAttribute('data-busy', '1');
      var note = $('[data-aba-extnote]', c);
      note.classList.add('is-warn');
      note.textContent = 'Busy edges: the stretched ' + (wide ? 'left and right' : 'top and bottom') + ' ends of this design may look streaky. When you use it, you can pick smooth ends instead.';
    });
    img.addEventListener('error', function () { c.classList.add('is-broken'); });
    if (ext) img.crossOrigin = 'anonymous'; // lets the busy-edge check and the end preview read the pixels (the AI server sends CORS *)
    img.src = im.url;
    if (S.busy) $$('button, input', c).forEach(function (x) { x.disabled = true; });
    return c;
  }
  // preview short side so the long side stays near max px
  function previewSize(B, short, max) { return Math.max(16, Math.min(short, Math.round(max / Math.max(B, 1 / B)))); }
  // "How should we fill the ends?" (busy designs on banners wider than 3:1 or taller than 1:3), as on the AI banner page
  function askEnds(c, id) {
    if (S.busy || !c) return;
    var panel = $('[data-aba-ends]', c);
    if (panel) { panel.hidden = false; c.classList.add('is-asking'); return; }
    var p = plan(), img = $('.aba-img', c), im = findImg(id);
    var A = im && im.w > 0 && im.h > 0 ? im.w / im.h : (img.naturalWidth / img.naturalHeight), wide = p.B > A;
    panel = el('div', 'aba-ends');
    panel.setAttribute('data-aba-ends', ''); panel.setAttribute('role', 'group'); panel.setAttribute('aria-label', 'How should we fill the ends?');
    panel.innerHTML =
      '<p class="aba-ends__t"><b>How should we fill the ends?</b> Your ' + esc(sizeLabel(p.w, p.h)) + ' banner is ' + (wide ? 'wider' : 'taller') + ' than this design, so we fill the ' + (wide ? 'left and right' : 'top and bottom') + ' ends from its edges. Its edges are busy, so stretched ends may look streaky.</p>' +
      '<div class="aba-ends__opts">' +
      '<button type="button" class="aba-endopt is-rec" data-aba-end="smooth"><span class="aba-endpic"></span><b>Smooth ends</b><small>A soft blend of the edge colors. Recommended</small></button>' +
      '<button type="button" class="aba-endopt" data-aba-end="stretch"><span class="aba-endpic"></span><b>Stretched ends</b><small>The edges stretched out as they are</small></button>' +
      '</div>' +
      '<button type="button" class="aba-link" data-aba-ends-back>Pick another design</button>';
    [['smooth', true], ['stretch', false]].forEach(function (k) {
      try { $('[data-aba-end="' + k[0] + '"] .aba-endpic', panel).appendChild(composeEnds(img, p.B, k[1], previewSize(p.B, 120, 900))); } catch (e) { /* the labels still explain it */ }
    });
    $('.aba-acts', c).parentNode.insertBefore(panel, $('.aba-acts', c));
    c.classList.add('is-asking');
    try { $('[data-aba-end="smooth"]', panel).focus({ preventScroll: true }); } catch (e) {}
    reveal(panel);
  }
  function closeEnds(c) { if (!c) return; var p = $('[data-aba-ends]', c); if (p) p.hidden = true; c.classList.remove('is-asking'); }

  // ---------- fix a word in one design ----------
  function fixDesign(id, text) {
    if (S.busy || !S.batch) return;
    var fix = clean(text).slice(0, LIMITS.fix);
    if (fix.length < 2) { cardErr(id, 'Tell us what to fix, like: Change "Snohomsh" to "Snohomish".'); return; }
    if (!S.hasEmail && S.fixesLeft === 0) { openGate(function () { fixDesign(id, fix); }, 'fix'); return; }
    cardErr(id, '');
    busy(true, 'Fixing it… redoing just that part.');
    botToken().then(function (token) {
      return api('/api/banner/fix', withEmail({ visitor: visitor, token: token, imageId: id, fix: fix }));
    }).then(function (j) {
      busy(false);
      if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
      syncQuota();
      if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
        if (j.error === 'need_email') { S.fixesLeft = 0; syncQuota(); openGate(function () { fixDesign(id, fix); }, 'fix'); return; }
        cardErr(id, j.message || 'That fix did not work. Please try again.');
        return;
      }
      var b = S.batch, idx = -1;
      b.images.forEach(function (x, i) { if (x.id === id) idx = i; });
      if (idx < 0) return;
      var next = Object.assign({}, j.images[0], { fixedFrom: id });
      b.images[idx] = next;
      var old = cardOf(id), fresh = cardFor(next, idx, plan());
      if (old && old.parentNode) old.parentNode.replaceChild(fresh, old);
      track('ardor_banner_ai_fixed', { style: b.style });
    });
  }

  // ---------- use a design: print-ready version, then onto the banner ----------
  function useDesign(id, ends) {
    if (S.busy || !S.batch) return;
    var b = S.batch, img = findImg(id);
    if (!img) return;
    cardErr(id, ''); showErr('');
    busy(true, 'Making a sharp, print-ready version… about 30 to 60 seconds.');
    botToken().then(function (token) {
      return api('/api/banner/final', withEmail({ visitor: visitor, token: token, imageId: id }), 300000);
    }).then(function (j) {
      if (j.finalsLeft != null) S.finalsLeft = j.finalsLeft;
      if (!j.ok || !j.image || !j.image.id) {
        busy(false);
        if (j.error === 'need_email') { openGate(function () { useDesign(id, ends); }, 'final'); return; }
        cardErr(id, j.message || 'We couldn\'t make the print version. Please try again.');
        return;
      }
      var fin = j.image, lb = validBox(fin.check && fin.check.logoBox) || validBox(img.check && img.check.logoBox);
      var L = LY();
      if (!L || !L.placeAi) { busy(false); cardErr(id, 'Please reload the page and try again.'); return; }
      var p = plan();
      $('[data-aba-status-t]').textContent = 'Putting it on your banner…';
      return L.placeAi({ id: fin.id, face: p.face, smooth: ends === 'smooth', logo: b.logoId || '', lb: lb, source: 'ai_drawer' }).then(function () {
        busy(false);
        track('ardor_banner_ai_used', { style: b.style, w: p.w, h: p.h, logo: !!b.logoId, ends: ends || '', face: p.face });
        if (L.closeDrawer) L.closeDrawer();
        if (L.toast) L.toast(b.logoId ? 'Your AI design is on your banner. Tap "Use my exact logo" to put your original logo file over the AI\'s version.' : 'Your AI design is on your banner. Add text or clipart, or drag it to move it.', b.logoId ? 9000 : 7000);
      });
    }).catch(function () { busy(false); cardErr(id, 'We couldn\'t put the design on your banner. Please try again.'); });
  }

  // ---------- start: wait for the builder and the drawer ----------
  var tries = 0;
  (function wait() {
    var host = root.querySelector('[data-aba-host]');
    if (host && BA() && LY()) { build(host); window.ArdorBannerAI = { plan: plan, quota: quota, state: S, generate: generate, useDesign: useDesign, showResults: showResults }; return; }
    if (++tries < 300) setTimeout(wait, 100);
  })();
})();
